import { FC } from 'react';
import { Image } from '~/components/image';
import { TComment } from 'shared/models';
import { useCommentImage } from '@article/body/comment/comment-item-image/use-comment-image';
import useReflowClick from '~/utils/use-reflow-click';
import { useActiveToCurrentArticle } from '@article/shared/utils/use-active-to-current-article';
import { ClickPosition } from '~/utils/click-position';

import './style.scss';

interface ICommentImageProps {
  comment: TComment;
}

export const CommentImage: FC<ICommentImageProps> = (props) => {
  const { comment } = props;
  const commentImage = useCommentImage(comment);
  const activeToCurrentPage = useActiveToCurrentArticle();

  if (!commentImage) {
    return null;
  }

  const { height, width, src, alt } = commentImage;

  const handleClickImage = useReflowClick(
    {
      reflowBehavior: () => {
        activeToCurrentPage(ClickPosition.comment_image);
      },
      defaultBehavior: () => {
        activeToCurrentPage(ClickPosition.comment_image);
      },
      clickEvent: () => ({
        current_position: ClickPosition.comment_reply,
        page_click_id: comment.commentId,
      }),
    },
    [activeToCurrentPage, comment],
  );

  return (
    <div
      className="comment-image"
      onClick={handleClickImage}
      style={{
        height,
        width,
      }}
    >
      <Image src={src} alt={alt} />
    </div>
  );
};
